// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 28Wh6oQMGtkZtGs1aVzLHN
// Component: lnNBtyPw6r3
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantsjSnjRsWLwTjq } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: JSnjRsWLwTjq/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_origin.module.css"; // plasmic-import: 28Wh6oQMGtkZtGs1aVzLHN/projectcss
import sty from "./PlasmicHomepageFooter.module.css"; // plasmic-import: lnNBtyPw6r3/css
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: 2P4nE2LbDCA/icon

export const PlasmicHomepageFooter__VariantProps = new Array();

export const PlasmicHomepageFooter__ArgProps = new Array();

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());

const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicHomepageFooter__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const [$queries, setDollarQueries] = React.useState({});
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsjSnjRsWLwTjq()
  });
  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <p.Stack
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox__owV8Y)}
      >
        <p.Stack
          as={"div"}
          hasGap={true}
          className={classNames(projectcss.all, sty.freeBox__s5NTp)}
        >
          <div className={classNames(projectcss.all, sty.freeBox__lqck9)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__roOjv
              )}
            >
              {"Kontakt"}
            </div>
            <a
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.link__mYzr6
              )}
            >
              {"Paštrovićeva 2, Beograd 11000, Serbia"}
            </a>
            <a
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.link__weTun
              )}
              href={"tel:+381612439221"}
            >
              {"+381612439221"}
            </a>
          </div>
        </p.Stack>
        {(hasVariant(globalVariants, "screen", "mobileOnly") ? true : true) ? (
          <p.Stack
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__i6O)}
          >
            <p.Stack
              as={"a"}
              hasGap={true}
              className={classNames(
                projectcss.all,
                projectcss.a,
                sty.link___1NdMx
              )}
            >
              {false ? (
                <IconIcon
                  className={classNames(projectcss.all, sty.svg__pOkve)}
                  role={"img"}
                />
              ) : null}
              {false ? (
                <IconIcon
                  className={classNames(projectcss.all, sty.svg__aSkbQ)}
                  role={"img"}
                />
              ) : null}
            </p.Stack>
          </p.Stack>
        ) : null}
        {false ? (
          <div className={classNames(projectcss.all, sty.freeBox__whmJ5)}>
            <button
              data-plasmic-name={"button"}
              data-plasmic-override={overrides.button}
              className={classNames(
                projectcss.all,
                projectcss.button,
                projectcss.__wab_text,
                sty.button
              )}
            >
              {"Sign up"}
            </button>
            <p.Stack
              as={"a"}
              hasGap={true}
              className={classNames(
                projectcss.all,
                projectcss.a,
                sty.link__rnwLr
              )}
            >
              {false ? (
                <IconIcon
                  className={classNames(projectcss.all, sty.svg___6FbUq)}
                  role={"img"}
                />
              ) : null}
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___7HDlF
                )}
              >
                {"Log in"}
              </div>
              {false ? (
                <IconIcon
                  className={classNames(projectcss.all, sty.svg__l8N0J)}
                  role={"img"}
                />
              ) : null}
            </p.Stack>
          </div>
        ) : null}
      </p.Stack>
      <div className={classNames(projectcss.all, sty.freeBox__qlqDl)} />
    </p.Stack>
  );
}

const PlasmicDescendants = {
  root: ["root", "button"],
  button: ["button"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHomepageFooter__ArgProps,
          internalVariantPropNames: PlasmicHomepageFooter__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicHomepageFooter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepageFooter";
  } else {
    func.displayName = `PlasmicHomepageFooter.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepageFooter = Object.assign(
  // Top-level PlasmicHomepageFooter renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    button: makeNodeComponent("button"),
    // Metadata about props expected for PlasmicHomepageFooter
    internalVariantProps: PlasmicHomepageFooter__VariantProps,
    internalArgProps: PlasmicHomepageFooter__ArgProps
  }
);

export default PlasmicHomepageFooter;
/* prettier-ignore-end */
